"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledChipSpinner = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var StyledChipSpinner = /*#__PURE__*/_styledComponents.default.span.withConfig({
  displayName: "StyledChipSpinner",
  componentId: "c11n-8-107-0__sc-1ab09lt-0"
})([""]);
exports.StyledChipSpinner = StyledChipSpinner;